import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { IEntityModel } from '@framework/interfaces/IEntityModel';
import { ViewType } from '@framework/core/Enums';
import { FormBuilderControl } from '@common/formbuilder/FormBuilderControl';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';

@Component({
  selector: 'app-mf-form-fields',
  templateUrl: './mf-form-fields.component.html',
  styleUrls: ['./mf-form-fields.component.css']
})
export class MfFormFieldsComponent implements OnInit {
  private _formFields: Array<FormBuilderControl>;
  private _data: any = {};
  public self = this;
  @Input() public parent: any;

  public get formFields(): Array<FormBuilderControl> { return this._formFields; }
  @Input() public formReadOnly: boolean = true;
  @Input() public set formFields(value: Array<FormBuilderControl>) { this._formFields = value; }
  @Input() public small:boolean = false;
  public get data() { return this._data; }
  @Input() public set data(value) {
    this._data = value;
    this.dataChange.emit(value);
  }

  
  public viewType = ViewType;

  constructor(private authService: IdentityAuthService,
    public cdr: ChangeDetectorRef) { }

  public ngOnInit() { }
  @Output() public dataChange = new EventEmitter();

  public fieldHidden(formField) {
    return !formField.show(this.data, this.authService, this.parent)
  }
}
